/* Anchors the existing native player; preserves an alternate view only during preview. */
(() => {
  if (customElements.get('ots-melody-actions')) return;
  customElements.define('ots-melody-actions', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.querySelector('.ots-story-listen')?.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const player = document.getElementById('OTSProductAudio');
        if (!player) return;
        event.preventDefault();
        const header = document.querySelector('.section-header');
        const top = Math.max(0, scrollY + player.getBoundingClientRect().top - (header?.offsetHeight || 0) - 24);
        player.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.events.signal });
      const initial = new URL(location.href);
      const view = this.dataset.view;
      if (view && initial.searchParams.get('view') === view && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          const current = new URL(location.href);
          if (current.pathname !== initial.pathname) return;
          current.searchParams.set('view', view);
          if (initial.searchParams.has('preview_theme_id')) current.searchParams.set('preview_theme_id', initial.searchParams.get('preview_theme_id'));
          history.replaceState(history.state, '', current);
        });
      }
    }
    disconnectedCallback() { this.events?.abort(); this.unsubscribe?.(); }
  });
})();
